import React from "react";
import { useIntl } from "react-intl";
import { inIframe, useCardProvider, noop, useSessionCtx, isNilOrEmpty } from "utils";
import Header from "flows/components/Header";
import { Error } from "components/Error";
import { FullPageSpinner } from "components/Spinner";
import { Page } from "components/Page";
import ContentContainer, { centeringBox } from "components/Container";
import { VStack } from "@chakra-ui/react";

export const IFrame = ({ children }) => {
  return <ContentContainer>{children}</ContentContainer>;
};

export const FullPage = ({ children }) => {
  return (
    <Page>
      <div style={centeringBox}>{children}</div>
    </Page>
  );
};

export const CreditCard = ({ config, onComplete, onReady = noop }) => {
  const { formatMessage } = useIntl();
  const { loading, error, Provider } = useCardProvider();
  const { debug } = useSessionCtx();

  // if config does not have 'provider', the use default.
  // if provider exists but does not have a resolvable value,
  // treat as an error
  if (isNilOrEmpty(Provider)) {
    debug("ERROR - Invalid provider:", config.provider);
    return <Error />;
  }

  const handleComplete = (result) => onComplete({ state: "complete", id: result });
  const handleCancel = () => onComplete({ state: "cancel" });

  if (loading) {
    return <FullPageSpinner />;
  }
  if (error) {
    return <Error />;
  }
  const Layout = inIframe() ? IFrame : FullPage;
  return (
    <Layout>
      <VStack spacing={5} align="stretch">
        <Header
          title={formatMessage({
            defaultMessage: "Add Credit Card",
            description: "Heading for Add Card flow",
          })}
          onCloseButtonClick={handleCancel}
          showLanguage
        />
        <Provider onComplete={handleComplete} onReady={onReady} />
      </VStack>
    </Layout>
  );
};
